/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesRequest,
  getCoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesResponse,
  getCoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesResponse';

type BulkCancelInvitesMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesRequest;

export type BulkCancelInvitesResult =
  CoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesResponse;

const validateBulkCancelInvitesResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiBulkCancelInvitesResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: BulkCancelInvitesResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  payload: Readonly<BulkCancelInvitesMutationArgs>,
  options?: RequestInit,
) => Promise<BulkCancelInvitesResult | ErrorTypes>;

export const getBulkCancelInvitesUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/invites/bulk-cancel${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Post BulkCancelInvites
 * @Url /organization/v1/invites/bulk-cancel
 * @Auth Required
 */
export const useBulkCancelInvites = (): HookReturnType => {
  const mutation = useMutation<unknown, BulkCancelInvitesResult>();

  const callback = useCallback(
    async (payload: Readonly<BulkCancelInvitesMutationArgs>, options?: RequestInit) => {
      const postBody = {
        user_id: payload.userId,
        legal_entity_ids: payload.legalEntityIds,
      };

      const init = { ...(options || {}), method: 'POST' };

      const url = getBulkCancelInvitesUrl();
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateBulkCancelInvitesResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
